var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.add)?_c('v-btn',{staticClass:"add",attrs:{"flat":"","small":"","color":"green","title":"Invite Member"}},[_c('v-icon',[_vm._v("add")]),_vm._v(" Invite\n")],1):_c('tr',[_c('td',[_c('Avatar',{staticClass:"profile-image",attrs:{"user":{photoURL: _vm.photoURL, displayName: _vm.displayName}}}),_vm._v("  "+_vm._s(_vm.displayName))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9a3430","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/MemberCard.vue
// module id = null
// module chunks = 